import {
  DEFAULT_FILL_OPACITY,
  DEFAULT_INACTIVE_FILL_OPACITY,
} from '../constants.js';

export const getOpacity = (isCurrentHighlighted: boolean) => {
  return isCurrentHighlighted
    ? DEFAULT_FILL_OPACITY
    : DEFAULT_INACTIVE_FILL_OPACITY;
};
